/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {interpolateWarning} from "./interpolate-warnings-filter";
import {LocalNetworkProfile} from '../../../../components/session/local-network-profile';

@Component({
  imports: [CommonModule],
  selector: 'simple-error-messages',
  template: `
    <div *ngIf="(errors && errors.length)" class="alert alert-danger">
      <p>Your submission had a validation error. Adjust your input according to the details below.</p>
      <ul>
        <li *ngFor="let error of errors">{{interpolateWarning(error.error)}}</li>
      </ul>
    </div>
  `
})
export class SimpleErrorMessagesComponent {
  @Input() errors: any;

  constructor(@Inject(LocalNetworkProfile)private LocalNetworkProfile) {
  }

  interpolateWarning(warning) {
    return interpolateWarning(warning, this.LocalNetworkProfile.isPureMarketplacePlatform());
  }
}
